// Selector de oră în format de 24 de ore: două liste, ora 00–23 și minutul 00–59.
// Înlocuiește <input type="time">, pe care Chrome îl arată cu AM/PM când browserul e
// pe engleză; pe 25.09.2026 o programare pentru 12 ziua a plecat la 12 noaptea.
// Valoarea rămâne "HH:MM" (sau '' cât timp nu e aleasă), ca înainte.

const ORE = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0'));
const MINUTE = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, '0'));

export default function OraMinut({ value, onChange, className, disabled }) {
  const [h, m] = (value || '').slice(0, 5).split(':');
  const ora = ORE.includes(h) ? h : '';
  const minut = MINUTE.includes(m) ? m : '';

  const schimba = (oraNoua, minutNou) => {
    if (!oraNoua) return onChange('');
    onChange(`${oraNoua}:${minutNou || '00'}`);
  };

  return (
    <span className={`ora-minut ${className || ''}`}>
      <select value={ora} disabled={disabled} aria-label="Ora"
        onChange={e => schimba(e.target.value, minut)}>
        {!ora && <option value="">--</option>}
        {ORE.map(o => <option key={o} value={o}>{o}</option>)}
      </select>
      <span className="ora-minut-sep">:</span>
      <select value={minut} disabled={disabled || !ora} aria-label="Minut"
        onChange={e => schimba(ora, e.target.value)}>
        {!minut && <option value="">--</option>}
        {MINUTE.map(o => <option key={o} value={o}>{o}</option>)}
      </select>
    </span>
  );
}
